import axiosInstance from './axios-instance';

export const checkVerificationCode = (verificationCode: string, userId: string) =>
  axiosInstance.post('user/verify', { verifiedCode: verificationCode, userId });
